import { useMutation } from '@tanstack/react-query'
import { instance } from '../constants/instance'
import { ApiReseponse } from '../types/ApiReseponse'
import { useError } from './useError'

type GenerateReportBody = {
  item: string
  email: string
}

type RegisterReportResponse = ApiReseponse<{ analysisToken: string }>
type SubmitAsinResponse = ApiReseponse<{ submissionId: string }>

async function registerReport(email: string): Promise<RegisterReportResponse> {
  const { data } = await instance.post(`/api/widget/register`, {
    email,
  })
  return data
}

async function sumbitAsin(
  asin: string,
  analysisToken: string
): Promise<SubmitAsinResponse> {
  const { data } = await instance.post(`/api/widget/asin/submit`, {
    asin,
    analysisToken,
  })
  return data
}

export function useGenerateReport() {
  const setError = useError((s) => s.setError)
  const resetError = useError((s) => s.reset)
  return useMutation<SubmitAsinResponse, Error, GenerateReportBody>({
    mutationKey: ['generate-report'],
    mutationFn: async (body) => {
      try {
        resetError()
        // const metadata = await getClientMetadata() // remove metadata as we have no need for it to start
        const registerResponse = await registerReport(body.email)
        const submitResponse = await sumbitAsin(
          body.item,
          registerResponse.data.analysisToken
        )

        return submitResponse
      } catch (e: any) {
        const message = e?.response?.data?.messages[0]
        if (message) {
          setError(message)
        }
        return Promise.reject(message)
      }
    },
  })
}
